import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';
import { EnergyComponent } from './energy.component';
import { EnergyMonitorComponent } from './energy-monitor/energy-monitor.component';
import { BidiChargingComponent } from './bidi-charging/bidi-charging.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'energy', component: EnergyComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['Customer', 'Operator'] },
          children: [
            {
              path: '',
              redirectTo: 'energy-monitor',
              pathMatch: 'full'
            },
            {
              path: 'energy-monitor',
              component: EnergyMonitorComponent
            },
            {
              path: 'bidi-charging',
              component: BidiChargingComponent,
            }
          ],
        }
      ]
    )
  ],
  providers: [
  ],
})
export class EnergyModule { }
